import { makeStyles } from "@material-ui/core";

const useRbCheckboxGroupStyles = makeStyles(() => ({
  root: (props) => ({
    flexDirection: props.variant === "row" ? "row" : undefined,
    alignItems: props.variant === "column" ? "flex-start" : undefined,
    paddingLeft: 11,
  }),
}));

export default useRbCheckboxGroupStyles;
